import { Tooltip } from "antd";
import { FolderOpenFilled } from "@ant-design/icons";

const Columns = (handleOpenChangeLog, filters) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultFilteredValue: filters.dashboardAssetsFilter,
      filters: filters.assets.map(asset => ({
        text: asset.name,
        value: asset.name
      })),
      onFilter: (value, record) => record.name === value,
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#FDE2E2",
          color: "#B22222",
          fontWeight: "bold",
        },
      }),
      showSorterTooltip: false,
      width: "25%",
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#FDE2E2",
          color: "#B22222",
          fontWeight: "bold",
        },
      }),
      showSorterTooltip: false,
      width: "40%",
    },
    {
      title: "Responsable",
      dataIndex: "area",
      key: "area",
      sorter: (a, b) =>
        (a.area?.name || "").localeCompare(b.area?.name || ""),
      defaultFilteredValue: filters.dashboardAreasFilter,
      filters: filters.areas.map(area => ({
        text: area.name,
        value: area.name
      })),
      onFilter: (value, record) => record.area?.name === value,
      render: (_, record) => record.area?.name || "N/A",
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#FDE2E2",
          color: "#B22222",
          fontWeight: "bold",
        },
      }),
      showSorterTooltip: false,
      width: "20%",
    },
    {
      title: "Creado por",
      dataIndex: "user",
      key: "user",
      sorter: (a, b) => {
        const usernameA = (a && a.user && a.user.username) ? a.user.username : "";
        const usernameB = (b && b.user && b.user.username) ? b.user.username : "";
        return usernameA.localeCompare(usernameB);
      },
      filters: filters.users.map(user => ({
        text: user.username,
        value: user.username
      })),
      onFilter: (value, record) => record.user?.username === value,
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      render: (user) => user?.username || "-",
      showSorterTooltip: false,
      width: '10%',
    },
    {
      title: "Log",
      dataIndex: "log",
      key: "log",
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } 
      }),
      width: '5%',
      render: (_, record) => (
        <div style={{ textAlign: 'center' }}>
          <Tooltip title="Ver Log">
            <FolderOpenFilled 
              style={{ fontSize: 20, cursor: 'pointer', color: '#B22222' }}
              onClick={() => handleOpenChangeLog(record)}
            />
          </Tooltip>
        </div>
      )
    }
  ];
};

export default Columns;
